// src/pages/StockPositionPage.jsx
import { Box, Typography } from "@mui/material";

const StockPositionPage = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                textAlign: "center",
                padding: 3,
            }}
        >
            <Typography variant="h4" fontWeight={700}>
                Posição de Estoque
            </Typography>

            <Typography variant="body1" color="text.secondary">
                Visão consolidada do estoque
            </Typography>
        </Box>
    );
};

export default StockPositionPage;
